const article = {
	slug: "gilchrist-winning-mindset",
	title: "When It Is Your Turn to Bat, Bat",
	date: "May 2026",
	updated: null,
	description: "Adam Gilchrist walked in the semifinal and dominated the final. Integrity and a winning mindset were the same thing.",
	keywords: ["leadership", "winning mindset", "integrity", "cricket"],
	tldr: "Gilchrist gave his wicket away for free in the semifinal, then batted like he owned the final. Integrity and winning are not opposites. That is how I want to lead.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, May 2026.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	video: "https://www.youtube.com/watch?v=Ih6LnU5J3bU",
	markdown: `He edged the ball to the keeper. The umpire didn't call it. World Cup semifinal. He turned and left anyway.

Days later, Wanderers Stadium. The Cricket World Cup final. He walked to the crease against India and you could feel the match turn before the scoreboard showed it.

57 off 48 balls. India never recovered.

The man who gave his wicket away for free in the semifinal played like he owned the final. That was Adam Gilchrist.

Integrity and winning. People act like you have to choose. Gilchrist didn't.

I wear this jersey when I need to remind myself what winning with integrity looks like.

It is the 2003 official ICC Cricket World Cup kit. I bought it for exactly that reason.

My son was born three months ago. I had not trained in weeks. I almost didn't go.

This morning I laced up and ran 13.1 miles through Brooklyn.

Gilly walked when no one forced him to.

Three days later he batted like the trophy was already his.

That is how I want to lead.

When it is your turn to bat, bat. When you have to walk, walk.`,
};

export default article;
